export const permissions = {
    instituicao: {
        leitura: 'instituicao-financeira:leitura',
        escrita: 'instituicao-financeira:escrita',
        relatorio_leitura: 'instituicao-financeira-relatorio:leitura'
    },
    usuario: {
        leitura: 'usuario:leitura',
        escrita: 'usuario:escrita'
    },
    af: {
        leitura: 'agente-financeiro:leitura',
        escrita: 'agente-financeiro:escrita'
    },
    contrato: {
        leitura: 'contrato:leitura',
        registro_escrita: 'contrato-registro:escrita',
        alterar_registro_escrita: 'contrato-alterar-registro:escrita',
        registro_aditivo_escrita: 'contrato-registro-aditivo:escrita',
        alterar_registro_aditivo_escrita:
            'contrato-alterar-registro-aditivo:escrita'
    },
    relatorio: { leitura: 'relatorio:leitura' },
    gestaoTaxas: {
        leitura: 'gestao-taxas:leitura',
        escrita: 'gestao-taxas:escrita'
    },
    alterarSenha: { leitura: 'contrato:leitura' }
}
